export const DEFAULT_TEAM_REPORT_LIMIT = 20;

export const TABLE_COLUMN = {
	User: 'user',
	Capacity: 'capacity',
	TimeOff: 'timeOff',
	ExtraAvailability: 'extraAvailability',
	Availability: 'availability',
	Bookings: 'bookings',
	BookingsFixed: 'bookingsFixed',
	BookingsTentative: 'bookingsTentative',
	BookingsVsAvailability: 'bookingsVsAvailability',
	TasksPlanned: 'tasksPlanned',
	TimeEntries: 'timeEntries',
	TimeEntriesScheduled: 'timeEntriesScheduled',
	TimeEntriesDone: 'timeEntriesDone',
	TimeEntriesVsAvailability: 'timeEntriesVsAvailability',
	TimeEntriesBillable: 'timeEntriesBillable',
	BillableTime: 'billableTime',
	TimeEntriesBillableVsAvailability: 'timeEntriesBillableVsAvailability',
	TimeEntriesNonBillable: 'timeEntriesNonBillable',
	TimeEntriesNonBillableVsAvailability:
		'timeEntriesNonBillableVsAvailability',
};

export const SORTABLE_COLUMNS = Object.values(TABLE_COLUMN);
